import {Navigate} from "react-router-dom";
import {useIdentityAuth} from "../context/IdentityAuthContext";
import {useAuthPermissions} from "../hooks/useAuthPermissions";
import SkeletonLoadingTS from "./SkeletonLoadingTS";

const ProtectedRoute = ({children, scope}) => {
  const {isLoading, isAuthenticated} = useIdentityAuth();
  const {verifyScope} = useAuthPermissions();

  if (isLoading) {
    return <SkeletonLoadingTS />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/acceso" replace />;
  }

  if (scope && !verifyScope(scope)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
